// eslint-disable-next-line import/no-internal-modules
import { GetServerSideProps } from '../../../../server-middleware/context'
import { FunctionalComponent } from 'preact'
import { z } from 'zod'

export const widgetName = 'gainsight-px-script' as const

// the data config
export const config = z.object({
  tag: z.string()
})

export type GainsightPxScriptConfig = z.infer<typeof config>

export interface GainsightPxScriptProps {
  tag: string
}

// the function which allows to alter config and get the context of execution
export const getServerSideProps: GetServerSideProps<GainsightPxScriptConfig, GainsightPxScriptProps> = async (
  _context,
  config
) => {
  return config
}

const GainsightPxScript: FunctionalComponent<GainsightPxScriptProps> = ({ tag }) => (
  <script
    dangerouslySetInnerHTML={{
      __html: createGainsightPxScript(tag)
    }}
  />
)

// default export is the component
export default GainsightPxScript

const createGainsightPxScript = (tag: string): string => `(function(n,t,a,e,co){var i="aptrinsic";n[i]=n[i]||function(){
(n[i].q=n[i].q||[]).push(arguments)},n[i].p=e;n[i].c=co;
var r=t.createElement("script");r.async=!0,r.src=a+"?a="+e;
var c=t.getElementsByTagName("script")[0];c.parentNode.insertBefore(r,c)
})(window,document,"https://web-sdk-eu.aptrinsic.com/api/aptrinsic.js","${tag}");`
